'use strict';

import {reverseUrl} from 'utils/django';

import StateDiagram from 'incidents/utils/states';
import Q from 'incidents/utils/states/query';

var UgSewerStateDiagram = new StateDiagram()
	.add('acknowledged', Q('acknowledged'))
	.add('complainant contacted', Q('contacts:call_completed', 'contacts:call_skipped'))
	.add('arrived', Q('geo:arrived'))
	.add('team required', Q('team:manager_contacted_for_formation'))
	.add('team forming', Q('team:global_formation_initialized'))
	.add('on-scene', Q('team:global_formation_complete', 'team:formation_skipped'))
	.add('work completed', Q('geo:departed'))
	.add('awaiting approval', Q('form_skipped'))
;


export default function(incident) {
	UgSewerStateDiagram.updateIncident(incident);
	incident.phoneFromUrl = reverseUrl('incidents:context:phone-number-list', {
		incident_uuid: incident.uuid,
	});
	incident.ProblemTypes = [
		{
			code: 'SSP',
			display: 'Sewer Pipes',
			subtypes: [
				{code: 'SS0000', display: 'Abandon'},
				{code: 'SS0010', display: 'Backup in Building'},
				{code: 'SS0020', display: 'Blockage'},
				{code: 'SS0040', display: 'Cleaning Needed'},
				{code: 'SS0050', display: 'CSO Bypassing'},
				{code: 'SS0070', display: 'Investigation Needed'},
				{code: 'SS0090', display: 'Locate'},
				{code: 'SS0100', display: 'Misaligned Or Separated Pipe'},
				{code: 'SS0110', display: 'New Installation'},
				{code: 'SS0120', display: 'Odor'},
				{code: 'SS0130', display: 'Pests'},
				{code: 'SS0140', display: 'Preventive Maintenance'},
				{code: 'SS0150', display: 'Restoration Needed'},
				{code: 'SS0160', display: 'Sag in Pipe'},
				{code: 'SS0170', display: 'Settlement/Cave-in'},
				{code: 'SS0190', display: 'Slow Building Drains'},
				{code: 'SS0200', display: 'Special Request'},
				{code: 'SS0210', display: 'Structural Issue'},
				{code: 'SS0220', display: 'Vegetation Maintenance Needed'},
				{code: 'SS0230', display: 'Wastewater at Ground Level'},
				{code: 'SS0125', display: 'Overflowing Manhole'},
				{code: 'SS0096', display: 'Mapping And Data Request'},
				{code: 'SS0175', display: 'Sewer Connection Verification'},
				{code: 'SS0145', display: 'Repair Visual Inspection Needed'},
				{code: 'SS0005', display: 'Asset Missing or Incorrect on Map'},
				{code: 'SW0175', display: 'Sewer Connection Verification'},
			],
		},
		{
			code: 'SSS',
			display: 'Sewer Structures',
			subtypes: [
				{code: 'SS0000', display: 'Abandon'},
				{code: 'SS0010', display: 'Backup in Building'},
				{code: 'SS0020', display: 'Blockage'},
				{code: 'SS0030', display: 'Buried Structure'},
				{code: 'SS0040', display: 'Cleaning Needed'},
				{code: 'SS0050', display: 'CSO Bypassing'},
				{code: 'SS0060', display: 'Grade Adjustment Needed'},
				{code: 'SS0070', display: 'Investigation Needed'},
				{code: 'SS0080', display: 'Lid/Grate Problem'},
				{code: 'SS0110', display: 'New Installation'},
				{code: 'SS0120', display: 'Odor'},
				{code: 'SS0130', display: 'Pests'},
				{code: 'SS0140', display: 'Preventive Maintenance'},
				{code: 'SS0150', display: 'Restoration Needed'},
				{code: 'SS0170', display: 'Settlement/Cave-in'},
				{code: 'SS0180', display: 'Sign Missing'},
				{code: 'SS0190', display: 'Slow Building Drains'},
				{code: 'SS0200', display: 'Special Request'},
				{code: 'SS0210', display: 'Structural Issue'},
				{code: 'SS0220', display: 'Vegetation Maintenance Needed'},
				{code: 'SS0230', display: 'Wastewater at Ground Level'},
				{code: 'SS0125', display: 'Overflowing Manhole'},
				{code: 'SS0096', display: 'Mapping And Data Request'},
				{code: 'SS0175', display: 'Sewer Connection Verification'},
				{code: 'SS0145', display: 'Repair Visual Inspection Needed'},
				{code: 'SS0005', display: 'Asset Missing or Incorrect on Map'},
			],
		},
		{
			code: 'SWC',
			display: 'Storm Conduit',
			subtypes: [
				{code: 'SW0000', display: 'Abandon'},
				{code: 'SW0010', display: 'Blockage'},
				{code: 'SW0030', display: 'Cleaning Needed'},
				{code: 'SW0040', display: 'Drainage Problem'},
				{code: 'SW0050', display: 'Erosion'},
				{code: 'SW0060', display: 'Flow Bypasses Existing Asset'},
				{code: 'SW0080', display: 'Suspect Illicit Discharge'},
				{code: 'SW0090', display: 'Investigation Needed'},
				{code: 'SW0110', display: 'Locate'},
				{code: 'SW0120', display: 'Misaligned Or Separated Pipe'},
				{code: 'SW0130', display: 'Pests'},
				{code: 'SW0140', display: 'Preventive Maintenance'},
				{code: 'SW0150', display: 'Restoration Needed'},
				{code: 'SW0160', display: 'Sag in Pipe'},
				{code: 'SW0170', display: 'Settlement/Cave-in'},
				{code: 'SW0180', display: 'Special Request'},
				{code: 'SW0190', display: 'Structural Damage'},
				{code: 'SW0200', display: 'Vegetation Maintenance Needed'},
				{code: 'SW0125', display: 'New Installation'},
				{code: 'SW0005', display: 'Basement Flooding - Non Sewage'},
				{code: 'SW0035', display: 'Creek/Stream Issue'},
				{code: 'SW0116', display: 'Mapping And Data Request'},
				{code: 'SWM0030', display: 'Graffiti On Box Culvert'},
				{code: 'SW0145', display: 'Repair Visual Inspection Needed'},
				{code: 'SW0002', display: 'Asset Missing or Incorrect on Map'},
				{code: 'SW0175', display: 'Sewer Connection Verification'},
			],
		},
		{
			code: 'SWS',
			display: 'Storm Structures',
			subtypes: [
				{code: 'SW0000', display: 'Abandon'},
				{code: 'SW0010', display: 'Blockage'},
				{code: 'SW0020', display: 'Buried Structure'},
				{code: 'SW0030', display: 'Cleaning Needed'},
				{code: 'SW0040', display: 'Drainage Problem'},
				{code: 'SW0050', display: 'Erosion'},
				{code: 'SW0070', display: 'Grade Adjustment Needed'},
				{code: 'SW0080', display: 'Suspect Illicit Discharge'},
				{code: 'SW0090', display: 'Investigation Needed'},
				{code: 'SW0100', display: 'Lid/Grate Problem'},
				{code: 'SW0110', display: 'Locate'},
				{code: 'SW0130', display: 'Pests'},
				{code: 'SW0140', display: 'Preventive Maintenance'},
				{code: 'SW0150', display: 'Restoration Needed'},
				{code: 'SW0170', display: 'Settlement/Cave-in'},
				{code: 'SW0180', display: 'Special Request'},
				{code: 'SW0190', display: 'Structural Damage'},
				{code: 'SW0200', display: 'Vegetation Maintenance Needed'},
				{code: 'SW0125', display: 'New Installation'},
				{code: 'SW0005', display: 'Basement Flooding - Non Sewage'},
				{code: 'SW0035', display: 'Creek/Stream Issue'},
				{code: 'SW0116', display: 'Mapping And Data Request'},
				{code: 'SW0145', display: 'Repair Visual Inspection Needed'},
				{code: 'SW0002', display: 'Asset Missing or Incorrect on Map'},
				{code: 'SW0175', display: 'Sewer Connection Verification'},
			],
		},
	];
}
